/**
 * The product's own name. Forge OS is the app; the tenant (e.g. CB Built
 * Homes) is the business using it. Use PRODUCT_NAME for app chrome, page
 * titles and "update available" copy; use the workspace name (useWorkspace())
 * wherever the text means the business. Never hard-code a tenant's name in
 * app chrome.
 */
export const PRODUCT_NAME = 'BizForge OS'
